<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Performance Tracking By Station</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-12">
            <div class="alert alert-danger" v-if="error">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </div>
        <div class="row flex">
          <div class="col-md-3">
            <h4>Area</h4>
            <v-select
              placeholder="SELECT AREA"
              v-model="shirtOrderStatusId"
              :options="areas"
              :reduce="(areas) => areas.id"
            />
          </div>
          <div class="col-md-3">
            <h4>From Date</h4>
            <VueCtkDateTimePicker
              format="YYYY-MM-DD"
              formatted="DD MMM YYYY"
              color="coral"
              v-model="fromDate"
              :no-label="true"
              :only-date="true"
              :auto-close="true"
              label="From Date"
            />
          </div>

          <div class="col-md-3">
            <h4>To Date</h4>
            <VueCtkDateTimePicker
              format="YYYY-MM-DD"
              formatted="DD MMM YYYY"
              color="coral"
              v-model="toDate"
              :no-label="true"
              :only-date="true"
              :auto-close="true"
              label="To Date"
            />
          </div>

          <div class="col-md-3 text-align-bottom">
            <button class="btn btn-primary" @click="getDataByStation()">
              GENERATE
            </button>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <vue-good-table
              :columns="columns"
              styleClass="table table-hover table-bordered"
              :rows="stations"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'time_delta'">
                  <span
                    :class="'text-bold ' + timeDeltaColor(props.row.time_delta)"
                    >{{ props.row.time_delta }} %</span
                  >
                </span>
                <span v-else-if="props.column.field == 'station_name'">
                  <router-link
                    :to="{
                      path:
                        '/performance_tracking/employees/' +
                        shirtOrderStatusId +
                        '/' +
                        props.row.station_id,
                    }"
                    class="text-bold text-capitalize"
                  >
                    {{ props.row.station_name }}
                  </router-link>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import AreaStatusMatching from "./tools/AreaStatusMatching.json";
import { VueGoodTable } from "vue-good-table";
import columns from "./tools/StationColumns.json";
import _ from "lodash";

export default {
  components: {
    VueCtkDateTimePicker,
    VueGoodTable,
  },
  data() {
    return {
      fromDate: moment().format(),
      toDate: moment().format(),
      areas: [],
      stations: [],
      columns: columns,
      shirtOrderStatusId: null,
      error: null,
    };
  },
  mounted() {
    $(".pt-sidebar").removeClass("active");
    $(".pt-stations").addClass("active");
    this.getAreas();
    let area = this.$route.params.area;
    if (area != undefined) {
      this.shirtOrderStatusId = area * 1;
      this.getDataByStation();
    }
  },
  methods: {
    getAreas() {
      let data = AreaStatusMatching.en;
      data.forEach((val) => {
        this.areas.push(val);
      });
    },
    async getDataByStation() {
      if (this.shirtOrderStatusId == null) {
        this.error = "Please Select Area";
      } else {
        this.error = null;
        let res = await axios.get("/performance_tracking/by_station", {
          params: {
            from_date: moment(this.fromDate).format("YYYY-MM-DD"),
            to_date: moment(this.toDate).format("YYYY-MM-DD"),
            shirt_order_status_id: this.shirtOrderStatusId,
          },
        });
        let data = res.data;
        this.stations = data;
      }
    },
    timeDeltaColor(value) {
      if (value > 0) {
        return "text-danger";
      } else if (value < 0) {
        return "text-success";
      }
    },
  },
};
</script>

<style scoped>
.text-align-bottom {
  align-self: flex-end;
}
.flex {
  display: flex;
}
.text-capitalize {
  text-transform: capitalize !important;
}
</style>
